import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useGlobalBottomOffsetValue, useGlobalTopOffsetValue } from '@infl-ts/util-global-sticky-offset';
import { Box } from '@mui/material';
import { UnknownBlockList } from '../../unknown-block-list';
import { jsx as _jsx } from "react/jsx-runtime";

var StickyBlock = function StickyBlock(_ref) {
  var _ref$block = _ref.block,
      blocks = _ref$block.blocks,
      positionBottom = _ref$block.positionBottom,
      href = _ref.href,
      leafBlocks = _ref.leafBlocks;
  var top = useGlobalTopOffsetValue();
  var bottom = useGlobalBottomOffsetValue();
  return /*#__PURE__*/_jsx(Box, {
    sx: _objectSpread(_objectSpread({
      display: 'flex',
      flexDirection: 'column',
      position: 'sticky'
    }, positionBottom ? {
      bottom: bottom
    } : {
      top: top
    }), {}, {
      zIndex: function zIndex(t) {
        return t.zIndex.stickyBlock;
      }
    }),
    "data-element": "Box",
    "data-component": "StickyBlock",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(UnknownBlockList, {
      blocks: blocks,
      href: href,
      leafBlocks: leafBlocks,
      "data-element": "UnknownBlockList",
      "data-component": "StickyBlock",
      "data-source-file": "index.tsx"
    })
  });
};

export default StickyBlock;